module.exports = __webpack_public_path__ + "img/avatar-6.a0ed0794.png";